// 火山引擎监控接入 https://www.volcengine.com/docs/6431/104857

// 在项目最开始的地方引入下面的代码
import browserClient from '@apmplus/web' // 配置参数
import { SPALoadPlugin } from '@apmplus/integrations'
import { isDev, isIot1, isLocalServer } from '@utils/utils'





const { VUE_APP_MODE, VUE_APP_EDITION, VUE_APP_VOLCENGINE_APPID, VUE_APP_VOLCENGINE_APPTOKEN } = process.env

/** 火山引擎埋点初始化 */
function initVolcengine() {

  const aid = Number(VUE_APP_VOLCENGINE_APPID) || 580058
  const token = VUE_APP_VOLCENGINE_APPTOKEN || '35919350efc44fe2b286cc8ce99ec0ab'

  // 上下文记录项目号, 要放在init之前, 否则pageview会没有projectID
  browserClient('context.set', 'projectID', window.getLocalStoragItem('projectcode') || '')

  browserClient('init', {
    aid, // 应用唯一标识，必填参数
    token, // 应用 token,必填参数
    plugins: {
      pageview: {
        routeMode: 'history', // hash or history
      },
    },
    // SPALoadPlugin主要是通过监听路由的变化，观察路由切换后的一系列关于dom变更、资源加载、请求发送等变更事件来寻找一个页面达到稳定态的时间，从而上报SPA_LOAD指标。
    integrations: [SPALoadPlugin()], // 手动引入SPALoadPlugin, 自动计算并上报SPA_LOAD
    env: VUE_APP_MODE, // 代码部署环境
    release: VUE_APP_EDITION, // 代码部署版本
    userId: window.getLocalStoragItem('ucloundid') || '', // 用户标识
  })

  // 更新配置
  // browserClient('config', {
  //   userId: 'test_user',
  // })

  browserClient('on', 'beforeSend', (eventData) => {
    // 更安全地获取错误信息
    const errorMsg = eventData?.message || 
                    eventData?.errorMessage || 
                    eventData?.error?.message || 
                    '';
    
    if (eventData?.type === 'error' && 
        (errorMsg.includes('cancel') || 
        errorMsg.includes('AbortError') || 
        errorMsg.includes('aborted'))) {
      return false; // 忽略这类错误
    }
    
    return eventData;
  });

  // 开启上报
  browserClient('start')
}

function init() {
  if (isDev()) return // 开发环境不加
  if (isLocalServer()) return // 本地服务不加
  if (isIot1()) return // 欧洲环境不加

  initVolcengine()
}

init()
